function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 10.5002,
  height: 1.00002,
  rx: 0.500009,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 4,
  width: 10.5002,
  height: 1.00002,
  rx: 0.500009,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 7,
  width: 10.5002,
  height: 1.00002,
  rx: 0.500009,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 1.5,
  r: 1,
  fill: "white",
  stroke: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 4.5,
  r: 1,
  fill: "white",
  stroke: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 7.5,
  r: 1,
  fill: "white",
  stroke: "currentColor"
});

function SvgSettingsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsicon);
export default __webpack_public_path__ + "static/media/settings.icon.e33b2d64.svg";
export { ForwardRef as ReactComponent };